import React from 'react';

const HeroSection = ({ headline, subheadline, backgroundImageUrl, ctaButtonText, ctaButtonLink }) => {
  return (
    <div 
      className="relative bg-cover bg-center h-[85vh] overflow-hidden"
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900/95 via-blue-900/80 to-indigo-900/70 animate-gradient-shift"></div>
      
      <div className="absolute top-20 right-20 w-80 h-80 bg-gradient-to-br from-blue-500/15 to-indigo-600/15 rounded-full blur-3xl animate-float-slow"></div>
      <div className="absolute bottom-32 left-16 w-64 h-64 bg-gradient-to-tr from-indigo-500/15 to-purple-500/15 rounded-full blur-2xl animate-float-reverse"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-r from-blue-600/10 to-indigo-600/10 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
        <div className="text-center md:text-left md:max-w-3xl">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight mb-3 leading-tight">
            {headline || 'Welcome to Baniuaga Group'}
          </h1>
          <p className="mt-2 text-lg md:text-xl text-white/90 sm:max-w-2xl font-light">
            {subheadline || 'Building a better future through innovation, integrity, and excellence'}
          </p>
          <div className="mt-10">
            <a
              href="#contact"
              className="inline-flex items-center bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-bold px-12 py-5 rounded-full shadow-2xl hover:shadow-blue-500/25 transition-all duration-500 ease-out transform hover:scale-105 hover:translate-y-[-2px] text-lg tracking-wide"
            >
              Partner With Us
            </a>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-10 left-0 right-0 text-center">
        <a href="#about" className="animate-bounce inline-block">
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </a>
      </div>
    </div>
  );
};

export default HeroSection;